import React from 'react';
import Form from 'react-bootstrap/Form';

import Const from '../../../util/Constants';
import Util from "../../../util/Util";
import ReportConst from '../../../util/ReportConst';

class AutomationModule extends React.Component {

  render() {
    const onChange = this.props.onChange;
    const model = this.props.model;
    const restricted = this.props.restricted && this.props.restricted.length 
      ? this.props.restricted : null;
    const models = [ 'lead', 'contact', 'sales_order', 'call', 'meeting', 'installment', 'property', 'project',
      'document','note'
    ].filter(model => {
      const view = this.props.models[model] && 
        Util.isAllow(this.props.models[model].permission, Const.PermView);
      const restrict = !restricted || restricted.find(innerModel => innerModel === model);
      return view && restrict;
    });
    return (
      <div className="form-group col-md-12">
        { models.map(innderModel =>
            <Form.Check key={innderModel}>
              <Form.Check.Input type="radio" checked={innderModel === model}
                onChange={() => onChange('model', innderModel)} />
              <Form.Check.Label>{this.props.models[innderModel].model_name}</Form.Check.Label>
            </Form.Check>
          )
        }
      </div>
    );
  }
}
export default AutomationModule;




// import React from 'react';
// import Select from 'react-select';

// import Const from '../../../util/Constants';
// import Util from "../../../util/Util";

// class AutomationModule extends React.Component {

//   render() {
//     const models = this.props.models;
//     const onChange = this.props.onChange;
//     const model = this.props.model;
//     const restricted = this.props.restricted && this.props.restricted.length
//       ? this.props.restricted : null;
//     const options = [ ];
//     if(Util.isAllow(models.lead.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'lead')))) {
//       options.push({ label: models.lead.model_name, value: 'lead' });
//     }
//     if(Util.isAllow(models.contact.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'contact')))) {
//       options.push({ label: models.contact.model_name, value: 'contact' });
//     }
//     if(Util.isAllow(models.sales_order.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'sales_order')))) {
//       options.push({ label: models.sales_order.model_name, value: 'sales_order' });
//     }
//     if(Util.isAllow(models.quote.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'quote')))) {
//       options.push({ label: models.quote.model_name, value: 'quote' });
//     }
//     if(Util.isAllow(models.call.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'call')))) {
//       options.push({ label: models.call.model_name, value: 'call' });
//     }
//     if(Util.isAllow(models.meeting.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'meeting')))) {
//       options.push({ label: models.meeting.model_name, value: 'meeting' });
//     }
//     if(Util.isAllow(models.installment.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'installment')))) {
//       options.push({ label: models.installment.model_name, value: 'installment' });
//     }
//     if(Util.isAllow(models.document.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'document')))) {
//       options.push({ label: models.document.model_name, value: 'document' });
//     }
//     if(Util.isAllow(models.note.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'note')))) {
//       options.push({ label: models.note.model_name, value: 'note' });
//     }
//     if(Util.isAllow(models.task.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'task')))) {
//       options.push({ label: models.task.model_name, value: 'task' });
//     }
//     if(Util.isAllow(models.ticket.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'ticket')))) {
//       options.push({ label: models.ticket.model_name, value: 'ticket' });
//     }
//     if(Util.isAllow(models.enquiry.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'enquiry')))) {
//       options.push({ label: models.enquiry.model_name, value: 'enquiry' });
//     }
//     if(Util.isAllow(models.mass_whatsapp.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'mass_whatsapp')))) {
//       options.push({ label: models.mass_whatsapp.model_name, value: 'mass_whatsapp' });
//     }
//     if(Util.isAllow(models.target.permission, Const.PermView) 
//       && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'target')))) {
//       options.push({ label: models.target.model_name, value: 'target' });
//     }

//     return (
//       <div className={`form-group col-md-${this.props.size ? this.props.size : 12}`}>
//         <Select
//           value={options.find(field => field.value === model)}
//           className="mr-sm-2"
//           options={options}
//           onChange={select => onChange('model', select ? select.value : null)}
//           isSearchable={true}
//           isClearable={true} />
//       </div>
//     );
//   }
// }
// export default AutomationModule;
